module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-genio-pratiche-collegate",
      "title": "Genio Pratiche Collegate"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f2eed05!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/GenioPraticheCollegate.vue
// module id = 837
// module chunks = 39